import { defineComponent as M, computed as p, openBlock as v, createElementBlock as g, normalizeClass as l, createElementVNode as L, createCommentVNode as w, createBlock as d, resolveDynamicComponent as B, withCtx as h, toDisplayString as f, watch as b, unref as z, createVNode as H, createTextVNode as y, renderSlot as _ } from "vue";
import { Dialog as k, DialogPanel as j, DialogTitle as A } from "@headlessui/vue";
const D = (e) => Object.fromEntries(
  Object.entries(e).filter(
    ([, c]) => c != null
  )
), m = (e) => (c) => {
  var i, V;
  const t = {
    ...e.defaultVariants,
    ...D(c || {})
  }, n = e.classes ? [e.classes] : [];
  for (const r in t) {
    const o = t[r], u = (V = (i = e.variants) == null ? void 0 : i[r]) == null ? void 0 : V[o];
    u && n.push(u);
  }
  const s = e.compoundVariants || [];
  for (let r = 0; r < s.length; r += 1) {
    const o = s[r];
    Object.keys(o).filter((C) => C !== "classes").every((C) => {
      const x = o[C];
      return x && Array.isArray(x) ? (o == null ? void 0 : o[C]).includes(t[C]) : o[C] === t[C];
    }) && o.classes && n.push(o.classes);
  }
  const a = {};
  return n.forEach((r) => {
    Object.entries(r).forEach(([o, u]) => {
      u && (a[o] = [a[o], u].filter(Boolean).join(" "));
    });
  }, {}), a;
}, S = m({
  classes: {
    svg: "fill-current"
  },
  defaultVariants: {
    size: "md"
  },
  variants: {
    size: {
      sm: {
        svg: "w-3 h-3"
      },
      md: {
        svg: "w-4 h-4"
      },
      lg: {
        svg: "w-5 h-5"
      }
    }
  }
}), N = {
  "arrow-down": {
    path: "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z",
    viewBox: "0 0 384 512"
  },
  "arrow-down-to-bracket": {
    path: "M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  "arrow-left": {
    path: "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z",
    viewBox: "0 0 448 512"
  },
  "arrow-right": {
    path: "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z",
    viewBox: "0 0 448 512"
  },
  "arrow-rotate-right": {
    path: "M456 224c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v80.1l-20-23.5C371 63.4 309.1 32 240 32C116.3 32 16 132.3 16 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C316.2 418.9 279.7 432 240 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2 0 0L402.9 176H312c-13.3 0-24 10.7-24 24s10.7 24 24 24H456z",
    viewBox: "0 0 512 512"
  },
  "arrow-up": {
    path: "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V115.9L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z",
    viewBox: "0 0 384 512"
  },
  "arrow-up-from-bracket": {
    path: "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87V328c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V344z",
    viewBox: "0 0 448 512"
  },
  "arrow-up-right-from-square": {
    path: "M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z",
    viewBox: "0 0 512 512"
  },
  "arrows-maximize": {
    path: "M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h70.1L224 222.1 81.9 80H152c13.3 0 24-10.7 24-24s-10.7-24-24-24H24C10.7 32 0 42.7 0 56V184c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9L190.1 256 48 398.1V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V456c0 13.3 10.7 24 24 24H152c13.3 0 24-10.7 24-24s-10.7-24-24-24H81.9L224 289.9 366.1 432H296c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24V328c0-13.3-10.7-24-24-24s-24 10.7-24 24v70.1L257.9 256 400 113.9V184c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24H296z",
    viewBox: "0 0 448 512"
  },
  barcode: {
    path: "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24zM464 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V56c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z",
    viewBox: "0 0 512 512"
  },
  bars: {
    path: "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  check: {
    path: "M440.1 103C450.3 112.4 450.3 127.6 440.1 136.1L176.1 400.1C167.6 410.3 152.4 410.3 143 400.1L7.029 264.1C-2.343 255.6-2.343 240.4 7.029 231C16.4 221.7 31.6 221.7 40.97 231L160 350.1L407 103C416.4 93.66 431.6 93.66 440.1 103V103z",
    viewBox: "0 0 448 512"
  },
  "chevron-down": {
    path: "M199 401c9.4 9.4 24.6 9.4 33.9 0L425 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L199 401z",
    viewBox: "0 0 448 512"
  },
  "chevron-left": {
    path: "M7 239c-9.4 9.4-9.4 24.6 0 33.9L199 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L57.9 256 233 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z",
    viewBox: "0 0 320 512"
  },
  "chevron-right": {
    path: "M297 239c9.4 9.4 9.4 24.6 0 33.9L105 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L71 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L297 239z",
    viewBox: "0 0 320 512"
  },
  "chevron-up": {
    path: "M199 111c9.4-9.4 24.6-9.4 33.9 0L425 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L41 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L199 111z",
    viewBox: "0 0 448 512"
  },
  "chevrons-down": {
    path: "M199 465c9.4 9.4 24.6 9.4 33.9 0L425 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L199 465zM7 81L199 273c9.4 9.4 24.6 9.4 33.9 0L425 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L41 47C31.6 37.7 16.4 37.7 7 47S-2.3 71.6 7 81z",
    viewBox: "0 0 448 512"
  },
  "chevrons-left": {
    path: "M7 239c-9.4 9.4-9.4 24.6 0 33.9L199 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L57.9 256 233 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239zM391 47L199 239c-9.4 9.4-9.4 24.6 0 33.9L391 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L425 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z",
    viewBox: "0 0 448 512"
  },
  "chevrons-right": {
    path: "M425 239c9.4 9.4 9.4 24.6 0 33.9L233 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L199 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L425 239zM41 47L233 239c9.4 9.4 9.4 24.6 0 33.9L41 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L7 81C-2.3 71.6-2.3 56.4 7 47s24.6-9.4 33.9 0z",
    viewBox: "0 0 448 512"
  },
  "chevrons-up": {
    path: "M233 47c-9.4-9.4-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L391 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L233 47zM425 431L233 239c-9.4-9.4-24.6-9.4-33.9 0L7 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L391 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z",
    viewBox: "0 0 448 512"
  },
  clone: {
    path: "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z",
    viewBox: "0 0 512 512"
  },
  "cloud-arrow-down": {
    path: "M223 312.1C213.7 303.6 213.7 288.4 223 279C232.4 269.7 247.6 269.7 256.1 279L296 318.1V184C296 170.7 306.7 160 320 160C333.3 160 344 170.7 344 184V318.1L383 279C392.4 269.7 407.6 269.7 416.1 279C426.3 288.4 426.3 303.6 416.1 312.1L336.1 392.1C327.6 402.3 312.4 402.3 303 392.1L223 312.1zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  "cloud-arrow-up": {
    path: "M303 175C312.4 165.7 327.6 165.7 336.1 175L416.1 255C426.3 264.4 426.3 279.6 416.1 288.1C407.6 298.3 392.4 298.3 383 288.1L344 249.9V384C344 397.3 333.3 408 320 408C306.7 408 296 397.3 296 384V249.9L256.1 288.1C247.6 298.3 232.4 298.3 223 288.1C213.7 279.6 213.7 264.4 223 255L303 175zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  "cloud-check": {
    path: "M307.8 371.8C296.9 382.7 279.1 382.7 268.2 371.8L204.2 307.8C193.3 296.9 193.3 279.1 204.2 268.2C215.1 257.3 232.9 257.3 243.8 268.2L288 312.4L396.2 204.2C407.1 193.3 424.9 193.3 435.8 204.2C446.7 215.1 446.7 232.9 435.8 243.8L307.8 371.8zM144 480C64.47 480 0 415.5 0 336C0 273.3 40.07 219.1 96 200.2V200C96 107.2 171.2 32 264 32C314.9 32 360.4 54.6 391.3 90.31C406.2 83.68 422.6 80 440 80C506.3 80 560 133.7 560 200C560 206.6 559.5 213 558.5 219.3C606.5 240.3 640 288.3 640 344C640 416.4 583.4 475.6 512 479.8V480H144zM264 80C197.7 80 144 133.7 144 200L144 234.1L111.1 245.5C74.64 258.7 48 294.3 48 336C48 389 90.98 432 144 432H506.6L509.2 431.8C555.4 429.2 592 390.8 592 344C592 308 570.4 276.9 539.2 263.3L505.1 248.4L511.1 211.7C511.7 207.9 512 204 512 200C512 160.2 479.8 128 440 128C429.5 128 419.6 130.2 410.8 134.2L378.2 148.7L354.9 121.7C332.8 96.08 300.3 80 263.1 80L264 80z",
    viewBox: "0 0 640 512"
  },
  code: {
    path: "M414.9 31.11L270.9 495.1C266.1 507.8 253.5 514.8 240.9 510.9C228.2 506.1 221.1 493.5 225.1 480.9L369.1 16.89C373 4.226 386.5-2.852 399.1 1.077C411.8 5.006 418.9 18.45 414.9 31.11V31.11zM504.4 118.5L632.4 238.5C637.3 243 640 249.4 640 255.1C640 262.6 637.3 268.1 632.4 273.5L504.4 393.5C494.7 402.6 479.6 402.1 470.5 392.4C461.4 382.7 461.9 367.6 471.6 358.5L580.9 255.1L471.6 153.5C461.9 144.4 461.4 129.3 470.5 119.6C479.6 109.9 494.7 109.4 504.4 118.5V118.5zM168.4 153.5L59.09 255.1L168.4 358.5C178.1 367.6 178.6 382.7 169.5 392.4C160.4 402.1 145.3 402.6 135.6 393.5L7.585 273.5C2.746 268.1 0 262.6 0 255.1C0 249.4 2.746 243 7.585 238.5L135.6 118.5C145.3 109.4 160.4 109.9 169.5 119.6C178.6 129.3 178.1 144.4 168.4 153.5V153.5z",
    viewBox: "0 0 640 512"
  },
  "compact-disc": {
    path: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z",
    viewBox: "0 0 512 512"
  },
  desktop: {
    path: "M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z",
    viewBox: "0 0 576 512"
  },
  "ellipsis-vertical": {
    path: "M48 464a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-160a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96z",
    viewBox: "0 0 128 512"
  },
  folder: {
    path: "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z",
    viewBox: "0 0 512 512"
  },
  "folder-open": {
    path: "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z",
    viewBox: "0 0 576 512"
  },
  gear: {
    path: "M208.1 51.4C220.3 49.2 233 48 246 48s25.7 1.2 37.9 3.4l8.5 35.1c4.1 17 15.6 29.8 28.9 37.4l1.4 .8c13.2 7.7 30.1 11.3 46.9 6.4l34.6-10.2c7.4 8.7 14.2 18 20.1 27.8l4 6.9c5.4 9.8 10.1 20.2 13.9 30.9l-26.2 24.9c-12.7 12-18 28.4-17.9 43.7l0 .8 0 .8c-.1 15.3 5.3 31.6 17.9 43.7l26.2 24.9c-3.8 10.7-8.5 21.1-13.9 30.9l-4 6.9c-5.9 9.8-12.7 19.1-20.1 27.8l-34.6-10.2c-16.8-5-33.7-1.4-46.9 6.4l-1.4 .8c-13.2 7.6-24.8 20.4-28.9 37.4l-8.5 35.1c-12.3 2.3-25 3.4-37.9 3.4s-25.7-1.2-37.9-3.4l-8.5-35.1c-4.1-17-15.6-29.8-28.9-37.4l-1.4-.8c-13.2-7.7-30.1-11.3-46.9-6.4L87.9 391.1c-7.4-8.7-14.2-18-20.1-27.8l-4-7c-5.4-9.8-10.1-20.2-13.9-30.9l26.2-24.9c12.7-12 18-28.4 17.9-43.7l0-.8 0-.8c.1-15.3-5.3-31.6-17.9-43.7L49.9 186.6c3.8-10.7 8.5-21.1 13.9-30.9l4-6.9c5.9-9.8 12.7-19.1 20.1-27.8l34.6 10.2c16.8 5 33.7 1.4 46.9-6.4l1.4-.8c13.2-7.6 24.8-20.4 28.9-37.4l8.5-35.1zM246 0c-17 0-33.6 1.7-49.8 4.8c-7.9 1.5-21.8 6.1-29.4 20.1c-2 3.7-3.6 7.6-4.6 11.8l-9.3 38.5c-.5 2-2.2 4.8-6 7c-.6 .4-1.2 .7-1.9 1.1c-3.8 2.2-7 2.3-9.1 1.7L98 73.8c-4-1.2-8.1-1.8-12.2-1.9c-16.1-.5-27 9.4-32.3 15.4c-10 11.4-19 23.8-26.9 36.9l0 0-.2 .4-4.2 7.3 0 0-.2 .4c-7.3 13.1-13.4 26.9-18.3 41.3C1 181.1-2 195.3 6.2 208.9c2.2 3.6 4.9 7 8 10L43 246.3c1.5 1.5 3 4.3 3 8.7l0 1.1 0 1.1c0 4.3-1.5 7.2-3 8.7L14.2 293.1c-3.1 3-5.8 6.4-8 10C-2 316.7 1 330.9 3.6 338.4c4.9 14.4 11 28.2 18.3 41.3l0 0 .2 .4 4.3 7.4 0 0 .2 .4c7.9 13.1 16.9 25.4 26.9 36.8c5.3 6 16.3 15.9 32.3 15.4c4.1-.1 8.2-.8 12.2-1.9L136 427c2-.6 5.3-.5 9.1 1.7c.6 .4 1.2 .7 1.9 1.1c3.8 2.2 5.5 4.9 6 7l9.3 38.5c1 4.2 2.6 8.2 4.6 11.8c7.7 14 21.6 18.5 29.4 20.1c16.1 3.2 32.8 4.8 49.8 4.8s33.6-1.7 49.8-4.8c7.9-1.5 21.8-6.1 29.4-20.1c2-3.7 3.6-7.6 4.6-11.8l9.3-38.5c.5-2 2.2-4.8 6-7c.6-.4 1.2-.7 1.9-1.1c3.8-2.2 7-2.3 9.1-1.7l38 11.2c4 1.2 8.1 1.8 12.2 1.9c16.1 .5 27-9.4 32.3-15.4c10-11.4 19-23.8 26.9-36.9l0 0 .2-.4 4.2-7.3 0 0 .2-.4c7.3-13.1 13.4-26.9 18.3-41.3c2.6-7.6 5.6-21.8-2.7-35.4c-2.2-3.6-4.9-7-8-10L449 265.7c-1.5-1.5-3-4.3-3-8.7l0-1.1 0-1.1c0-4.3 1.5-7.2 3-8.7l28.7-27.3c3.1-3 5.8-6.4 8-10c8.2-13.6 5.2-27.8 2.7-35.4c-4.9-14.4-11-28.2-18.3-41.3l0 0-.2-.4-4.2-7.3 0 0-.2-.4c-7.9-13.1-16.9-25.4-26.9-36.9c-5.3-6-16.3-15.9-32.3-15.4c-4.1 .1-8.2 .8-12.2 1.9L356 85c-2 .6-5.3 .5-9.1-1.7c-.6-.4-1.2-.7-1.9-1.1c-3.8-2.2-5.5-4.9-6-7l-9.3-38.5c-1-4.2-2.6-8.2-4.6-11.8c-7.7-14-21.6-18.5-29.4-20.1C279.6 1.7 263 0 246 0zM198 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z",
    viewBox: "0 0 512 512"
  },
  language: {
    path: "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H272h32 16H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H320 304 272 64zm512 48c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H320V112H576zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316H123.2l-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276h38zM456 164c-11 0-20 9-20 20v4H384c-11 0-20 9-20 20s9 20 20 20h72 35.1c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228h2c11 0 20-9 20-20s-9-20-20-20H520 476v-4c0-11-9-20-20-20z",
    viewBox: "0 0 640 512"
  },
  "laptop-mobile": {
    path: "M128 48H448c8.8 0 16 7.2 16 16V96h48V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64V320H16c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48H352V320H112V64c0-8.8 7.2-16 16-16zM384 176V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48zm48 0H592V464H432V176z",
    viewBox: "0 0 640 512"
  },
  "magnifying-glass": {
    path: "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z",
    viewBox: "0 0 512 512"
  },
  microphone: {
    path: "M224 96V256c0 26.5-21.5 48-48 48s-48-21.5-48-48V96c0-26.5 21.5-48 48-48s48 21.5 48 48zM80 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S80 43 80 96zM48 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H104c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H200V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z",
    viewBox: "0 0 384 512"
  },
  minus: {
    path: "M416 256c0 13.3-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z",
    viewBox: "0 0 448 512"
  },
  mobile: {
    path: "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H288c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM144 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
    viewBox: "0 0 384 512"
  },
  moon: {
    path: "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z",
    viewBox: "0 0 384 512"
  },
  pencil: {
    path: "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z",
    viewBox: "0 0 512 512"
  },
  plus: {
    path: "M232 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H184V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V72z",
    viewBox: "0 0 448 512"
  },
  share: {
    path: "M288 240H192c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128H288h24c13.3 0 24-10.7 24-24V128 99.9L456.1 208 336 316.1V288 264c0-13.3-10.7-24-24-24H288zm0 48v48 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V80v48H240 176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96h48 48z",
    viewBox: "0 0 512 512"
  },
  spinner: {
    path: "M288 32C288 49.67 273.7 64 256 64C238.3 64 224 49.67 224 32C224 14.33 238.3 0 256 0C273.7 0 288 14.33 288 32zM288 480C288 497.7 273.7 512 256 512C238.3 512 224 497.7 224 480C224 462.3 238.3 448 256 448C273.7 448 288 462.3 288 480zM480 224C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288C462.3 288 448 273.7 448 256C448 238.3 462.3 224 480 224zM32 288C14.33 288 0 273.7 0 256C0 238.3 14.33 224 32 224C49.67 224 64 238.3 64 256C64 273.7 49.67 288 32 288zM74.98 391.8C87.48 379.3 107.7 379.3 120.2 391.8C132.7 404.3 132.7 424.5 120.2 437C107.7 449.5 87.48 449.5 74.98 437C62.48 424.5 62.48 404.3 74.98 391.8zM391.8 437C379.3 424.5 379.3 404.3 391.8 391.8C404.3 379.3 424.5 379.3 437 391.8C449.5 404.3 449.5 424.5 437 437C424.5 449.5 404.3 449.5 391.8 437zM120.2 74.98C132.7 87.48 132.7 107.7 120.2 120.2C107.7 132.7 87.48 132.7 74.98 120.2C62.48 107.7 62.48 87.48 74.98 74.98C87.48 62.49 107.7 62.49 120.2 74.98z",
    viewBox: "0 0 512 512"
  },
  "sun-bright": {
    path: "M280 24V88c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9l-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H424c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8L108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9L437 403.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V424c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z",
    viewBox: "0 0 512 512"
  },
  tablet: {
    path: "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
    viewBox: "0 0 448 512"
  },
  "text-size": {
    path: "M48 128V80H168l0 352H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H216l0-352H336v48c0 13.3 10.7 24 24 24s24-10.7 24-24V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296V272h96l0 160H424c-13.3 0-24 10.7-24 24s10.7 24 24 24H536c13.3 0 24-10.7 24-24s-10.7-24-24-24H504l0-160h88v24c0 13.3 10.7 24 24 24s24-10.7 24-24V264c0-22.1-17.9-40-40-40H352c-22.1 0-40 17.9-40 40v32c0 13.3 10.7 24 24 24s24-10.7 24-24z",
    viewBox: "0 0 640 512"
  },
  trash: {
    path: "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z",
    viewBox: "0 0 448 512"
  },
  "triangle-exclamation": {
    path: "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z",
    viewBox: "0 0 512 512"
  },
  user: {
    path: "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z",
    viewBox: "0 0 448 512"
  },
  xmark: {
    path: "M313 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L7 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L279 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L313 137z",
    viewBox: "0 0 320 512"
  }
}, E = ["viewBox"], P = ["d"], T = {
  name: "VtIcon"
}, $ = /* @__PURE__ */ M({
  ...T,
  props: {
    name: {},
    size: {}
  },
  setup(e) {
    const c = e, t = p(() => N[c.name]), n = p(() => S({ size: c.size }));
    return (s, a) => t.value ? (v(), g("svg", {
      key: 0,
      viewBox: t.value.viewBox,
      "aria-hidden": "true",
      class: l(n.value.svg)
    }, [
      L("path", {
        d: t.value.path
      }, null, 8, P)
    ], 10, E)) : w("", !0);
  }
}), O = m({
  classes: {
    button: "flex flex-row gap-2 focus:ring-4 font-medium rounded-full focus:outline-none cursor-pointer pointer-events-auto",
    text: "",
    icon: ""
  },
  defaultVariants: {
    intent: "secondary",
    size: "md",
    display: "normal",
    disabled: !1,
    iconPosition: "start"
  },
  variants: {
    intent: {
      primary: {
        button: "text-primary-50 bg-primary-600 hover:bg-primary-800 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
      },
      secondary: {
        button: "bg-green-500"
      },
      tertiary: {
        button: "text-neutral-900 bg-transparent hover:bg-neutral-100 focus:ring-neutral-200 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:focus:ring-neutral-600"
      }
    },
    iconPosition: {
      start: { button: "row" },
      end: { button: "row-reverse" }
    },
    size: {
      sm: { button: "text-sm px-4 py-2" },
      md: { button: "text-sm px-4 py-2" },
      lg: { button: "text-sm px-4 py-2" }
    },
    display: {
      "full-width": {
        button: "w-full"
      },
      "icon-only": {
        text: "sr-only"
      }
    }
  },
  compoundVariants: [
    { size: "md", display: "icon-only", classes: { button: "!p-2" } }
  ]
}), I = {
  name: "VtButton"
}, F = /* @__PURE__ */ M({
  ...I,
  props: {
    text: {},
    type: { default: "button" },
    intent: { default: "secondary" },
    tagName: { default: "button" },
    icon: { default: void 0 },
    size: { default: "md" },
    display: { default: "normal" },
    disabled: { type: Boolean }
  },
  setup(e) {
    const c = e, t = p(() => typeof c.icon == "object" ? c.icon.icon : c.icon), n = p(() => typeof c.icon == "object" ? c.icon.position ?? "start" : "start"), s = p(() => O({
      intent: c.intent,
      size: c.size,
      display: c.display,
      disabled: c.disabled,
      iconPosition: n.value
    })), a = p(() => c.display === "icon-only" ? c.text : void 0);
    return (i, V) => (v(), d(B(i.tagName), {
      type: i.type,
      disabled: i.disabled,
      class: l(s.value.button),
      title: a.value
    }, {
      default: h(() => [
        t.value ? (v(), d($, {
          key: 0,
          name: t.value,
          class: l(s.value.icon)
        }, null, 8, ["name", "class"])) : w("", !0),
        L("span", {
          class: l(s.value.text)
        }, f(i.text), 3)
      ]),
      _: 1
    }, 8, ["type", "disabled", "class", "title"]));
  }
}), q = m({
  classes: {
    container: "",
    overlay: "fixed z-30 inset-0 bg-neutral-900 opacity-50 dark:opacity-80",
    dialog: "fixed z-30 inset-0 bg-neutral-50 rounded-lg shadow dark:bg-neutral-700 w-11/12 max-w-lg flex flex-col m-auto h-fit max-h-full",
    hgroup: "px-6 py-4 border-b rounded-t dark:border-neutral-600 flex gap-4 items-center justify-between",
    hgroupText: "text-base font-semibold text-neutral-900 lg:text-xl dark:text-neutral-50",
    hgroupAction: "",
    main: "p-6 flex-1 overflow-y-auto max-h-96"
  }
}), G = {
  name: "VtDialog"
}, Q = /* @__PURE__ */ M({
  ...G,
  props: {
    open: { type: Boolean },
    titleText: {},
    initialFocus: {}
  },
  emits: ["update:open", "open", "close"],
  setup(e, { emit: c }) {
    const t = e, n = () => {
      c("update:open", !1);
    }, s = p(() => q());
    return b(
      () => t.open,
      (a) => {
        c(a ? "open" : "close");
      },
      { flush: "post" }
    ), (a, i) => (v(), d(z(k), {
      as: "div",
      class: l(s.value.container),
      open: a.open,
      "initial-focus": z(a.initialFocus),
      onClose: n
    }, {
      default: h(() => [
        L("div", {
          class: l(s.value.overlay),
          "aria-hidden": "true"
        }, null, 2),
        H(z(j), {
          class: l(s.value.dialog)
        }, {
          default: h(() => [
            L("hgroup", {
              class: l(s.value.hgroup)
            }, [
              H(z(A), {
                as: "h3",
                class: l(s.value.hgroupText)
              }, {
                default: h(() => [
                  y(f(a.titleText), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              H(F, {
                type: "button",
                display: "icon-only",
                icon: "xmark",
                text: "Close dialog",
                intent: "tertiary",
                class: l(s.value.hgroupAction),
                onClick: n
              }, null, 8, ["class"])
            ], 2),
            L("div", {
              class: l(s.value.main)
            }, [
              _(a.$slots, "default")
            ], 2)
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["class", "open", "initial-focus"]));
  }
});
export {
  F as VtButton,
  Q as VtDialog,
  $ as VtIcon,
  m as defineComponentClasses
};
